import { render } from "./AppVersion.vue?vue&type=template&id=4d56051b&scoped=true"
import script from "./AppVersion.vue?vue&type=script&lang=js"
export * from "./AppVersion.vue?vue&type=script&lang=js"

import "./AppVersion.vue?vue&type=style&index=0&id=4d56051b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d56051b"]])

export default __exports__